"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddIcon = function AddIcon() {
  return _react2.default.createElement(
    "svg",
    { className: "quiver-add-icon", viewBox: "0 0 20 20" },
    _react2.default.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "none", vectorEffect: "non-scaling-stroke" }),
    _react2.default.createElement("path", { d: "M10 5 L 10 15", fill: "none", strokeLinecap: "round", vectorEffect: "non-scaling-stroke" }),
    _react2.default.createElement("path", { d: "M5 10 L 15 10", fill: "none", strokeLinecap: "round", vectorEffect: "non-scaling-stroke" })
  );
};

exports.default = AddIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/AddIcon/AddIcon.js
// module id = 260
// module chunks = 0